<template>
  <div class="__currency-amount">
    <el-tooltip
      class="item"
      effect="dark"
      :content="content"
      :placement="placement"
      :open-delay="delay"
      :disabled="!tooltip"
    >
      <span>
        <span :class="{ 'small-symbol': smallSymbol }" v-if="currency">{{ symbol }}</span>
        <span>{{ FormattedNumber }}</span>
      </span>
    </el-tooltip>
  </div>
</template>

<script>
/*
  金額表示用に数値を整形する。
  例）123456 -> $12,345.00

  [Props]
  value（必須） : 整形前の金額。数値以外が入るとエラー。
  currency : 通貨。デフォルトは 'false'。
  symbol : 通貨のタイプ。デフォルトは '$'。
  small-symbol : 通貨シンボルのサイズを小さく表示させる。デフォルトは 'false'。
 */

import { numberFormat } from '../../lib/formattingAmounts';

export default {
  name: 'CurrencyAmount',
  props: {
    value: {
      type: [String, Number],
      default: '',
      required: true,
    },
    currency: Boolean,
    symbol: {
      type: String,
      default: '$',
    },
    smallSymbol: [Boolean],
    tooltip: [String, Number],
    placement: {
      type: String,
      default: 'top',
    },
    openDelay: {
      type: [String, Number],
      default: 500,
    },
  },
  computed: {
    FormattedNumber() {
      return numberFormat(this.value);
    },
    content() {
      return String(this.tooltip);
    },
    delay() {
      return Number(this.openDelay);
    },
  },
};
</script>

<style lang="scss" scoped>
.__currency-amount {
  display: inline-block;
  .small-symbol {
    font-size: 0.7em;
  }
}
</style>
